/**
 * gos-premium.js
 * Minimal vanilla JS enhancements for Game of Stones premium theme.
 * No external dependencies. All wrapped in DOMContentLoaded.
 */

(function () {
  'use strict';

  /* ============================================================
     1. SCROLL REVEAL — IntersectionObserver for custom sections
     ============================================================ */
  function initScrollReveal () {
    var elements = document.querySelectorAll(
      '.gos-trust-item, .gos-brand-item, .gos-founder-story__timeline-item, ' +
      '.gos-social-proof__stat, .gos-instagram-gallery__item'
    );
    if (!elements.length || !window.IntersectionObserver) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('gos-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ============================================================
     2. INSTAGRAM GALLERY — Touch/Swipe Slider (Mobile)
     ============================================================ */
  function initInstagramSlider () {
    var grids = document.querySelectorAll('.gos-instagram-gallery__grid');
    grids.forEach(function (grid) {
      var startX   = 0;
      var startScrollLeft = 0;
      var isDragging = false;

      grid.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startScrollLeft = grid.scrollLeft;
        isDragging = true;
      }, { passive: true });

      grid.addEventListener('touchmove', function (e) {
        if (!isDragging) return;
        var dx = startX - e.touches[0].clientX;
        grid.scrollLeft = startScrollLeft + dx;
      }, { passive: true });

      grid.addEventListener('touchend', function () {
        isDragging = false;
      });

      /* Mouse drag for desktop testing */
      grid.addEventListener('mousedown', function (e) {
        isDragging   = true;
        startX       = e.clientX - grid.offsetLeft;
        startScrollLeft = grid.scrollLeft;
        grid.style.cursor = 'grabbing';
      });

      grid.addEventListener('mouseleave', function () {
        isDragging = false;
        grid.style.cursor = '';
      });

      grid.addEventListener('mouseup', function () {
        isDragging = false;
        grid.style.cursor = '';
      });

      grid.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        e.preventDefault();
        var x  = e.clientX - grid.offsetLeft;
        var walk = (x - startX) * 1.5;
        grid.scrollLeft = startScrollLeft - walk;
      });
    });
  }

  /* ============================================================
     3. STICKY MOBILE ADD-TO-CART BAR
     ============================================================ */
  function initStickyMobileATC () {
    var bar = document.getElementById('gos-sticky-atc');
    if (!bar) return;

    var mainAtc = document.querySelector('.product-form__submit, [name="add"]');
    if (!mainAtc) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('gos-sticky-atc--visible');
        } else {
          bar.classList.add('gos-sticky-atc--visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(mainAtc);
  }

  /* ============================================================
     4. COUNTDOWN TIMER
     ============================================================ */
  function initCountdownTimers () {
    var timers = document.querySelectorAll('[data-gos-countdown]');
    timers.forEach(function (el) {
      var target = new Date(el.dataset.gosCountdown);
      if (isNaN(target)) return;

      function update () {
        var now  = new Date();
        var diff = target - now;
        if (diff <= 0) {
          el.textContent = 'Offer Ended';
          return;
        }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        el.textContent =
          pad(h) + ':' + pad(m) + ':' + pad(s);
        setTimeout(update, 1000);
      }

      function pad (n) { return n < 10 ? '0' + n : n; }
      update();
    });
  }

  /* ============================================================
     5. PRODUCT CARD — Quick View hover label
     ============================================================ */
  function initCardHoverStates () {
    var cards = document.querySelectorAll('.card-wrapper');
    cards.forEach(function (card) {
      var img = card.querySelector('.card__media img');
      if (!img) return;

      card.addEventListener('mouseenter', function () {
        card.classList.add('gos-card-hovered');
      });
      card.addEventListener('mouseleave', function () {
        card.classList.remove('gos-card-hovered');
      });
    });
  }

  /* ============================================================
     6. ANNOUNCEMENT BAR — Smooth auto-scroll if multiple messages
     ============================================================ */
  function initAnnouncementBar () {
    var bar = document.querySelector('.announcement-bar-slider');
    if (!bar) return;
    /* Dawn's slider-component handles this natively — just ensure
       our CSS transitions don't conflict */
    bar.style.willChange = 'transform';
  }

  /* ============================================================
     7. SMOOTH SCROLL for anchor links
     ============================================================ */
  function initSmoothScroll () {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var target = document.querySelector(anchor.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ============================================================
     INIT
     ============================================================ */
  document.addEventListener('DOMContentLoaded', function () {
    initScrollReveal();
    initInstagramSlider();
    initStickyMobileATC();
    initCountdownTimers();
    initCardHoverStates();
    initAnnouncementBar();
    initSmoothScroll();
  });

  /* Re-init on Shopify theme editor section loads */
  document.addEventListener('shopify:section:load', function (e) {
    initScrollReveal();
    initInstagramSlider();
    initCountdownTimers();
    initCardHoverStates();
  });

})();
